import { KeyValuePair } from '@app/core/models/keyValuePair';

class TrymaWaterChannelPositions {
  None = { key: 0, value: 'Geen' };
  Front = { key: 1, value: 'Voorzijde' };
  Under = { key: 2, value: 'Onderzijde' };
}
const trymaWaterChannelPositions = new TrymaWaterChannelPositions();
const keyValuePairs: Array<KeyValuePair> = [
    trymaWaterChannelPositions.None,
    trymaWaterChannelPositions.Front,
    trymaWaterChannelPositions.Under
];

export {
    trymaWaterChannelPositions,
    keyValuePairs
};
